import gql from 'graphql-tag';

const GET_ANALYTICS_TASKS = gql`
  query analyticsTasksConnection(
    $where: TaskWhereInput
    $orderBy: TaskOrderByInput
    $first: Int
  ) {
    tasksConnection(where: $where, orderBy: $orderBy, first: $first) {
      edges {
        node {
          id
          status
          requestType
          requestSubType
          urgency
          createdAt
          updatedAt
          dueDate
          createdBy {
            id
            name
            roles {
              id
              org {
                id
                name
                level
              }
            }
          }
          assigneeUser {
            id
            name
          }
          assigneeUsers {
            id
            name
          }
          advertiser {
            id
            name
          }
          channelPartner {
            id
            name
          }
          project {
            id
            name
          }
        }
      }
      aggregate {
        count
      }
    }
  }
`;

export default GET_ANALYTICS_TASKS;
